import { memo } from 'react';
import type { ShipmentStatusMapping } from '../../models/shipmentStatusMapping.types';
import { DropdownActions } from '../interaction/DropdownActions';
import { MappingStatusBadge } from './MappingStatusBadge';

interface MappingListRowProps {
  mapping: ShipmentStatusMapping;
  isLast: boolean;
  canUpdate?: boolean;
  onEditMapping: (mapping: ShipmentStatusMapping) => void;
  onUnmapMapping: (mapping: ShipmentStatusMapping) => void;
}

export const MappingListRow = memo(function MappingListRow({
  mapping,
  isLast,
  canUpdate = false,
  onEditMapping,
  onUnmapMapping,
}: MappingListRowProps) {
  return (
    <div
      className={`grid grid-cols-[1fr_auto_2.5rem] items-center gap-3 px-4 py-3.5 sm:py-4 ${
        isLast ? '' : 'border-b border-border'
      }`}
      data-testid={`mapping-row-${mapping.id}`}
    >
      <div className="min-w-0">
        <p className="truncate text-sm font-medium text-foreground" title={mapping.status_description}>
          {mapping.status_description}
        </p>
        <p className="mt-0.5 truncate text-xs text-muted-foreground">{mapping.courier.name}</p>
      </div>

      <MappingStatusBadge shipmentStatus={mapping.shipment_status} />

      <div className="flex justify-end">
        {canUpdate ? (
          <DropdownActions
            mapping={mapping}
            onEdit={() => onEditMapping(mapping)}
            onUnmap={() => onUnmapMapping(mapping)}
          />
        ) : null}
      </div>
    </div>
  );
});
